import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { isNull } from '../../lib/utils'
import Text from '../Text/Text'
import Image from '../Image/Image'
import NotificationCardHeader from './NotificationCardHeader'
import ActionButton from '../ActionButton/ActionButton'
import { getFormatedCreatedAt } from '../../lib/dates'
import TagAnalytics from '../../lib/tag-analytics/v2'
import styles from './notificationCard.scss'

import colors from '../../styles/theme/colors.scss'

import defaultImage from './defaultImage.svg'

export const openURLInNewTab = (url) => {
  const newTab = window.open(url, '_blank')

  if (newTab) newTab.focus()

  return newTab
}

export const handleAnalytics = (eventName = 'customPageView') => {
  TagAnalytics(eventName, {
    site: {
      subEnvironment: 'cdn'
    },
    page: {
      flowType: 'cockpit-cdn',
      pageType: 'cockpit-cdn',
      pageName: '/webmotors/cockpit/cdn',
      'pageName.tier1': 'cockpit',
      'pageName.tier2': 'cdn',
      'pageName.tier3': undefined,
      loadTime: window.performance.PerformanceNavigationTiming
    }
  })
}
export const defaultOnClickAction = (action = {}) => {
  const { url = null, trackingAnalytics } = action
  trackingAnalytics && handleAnalytics(`notificacao-cdn-${trackingAnalytics}`)
  if (!url) return null
  return openURLInNewTab(url)
}

export const isRead = (readAt) => !isNull(readAt)

export const isInterected = (interectedAt) => !isNull(interectedAt)

class NotificationCard extends React.Component {
  constructor(props) {
    super(props)

    this.handleRemoveConfirm = this.handleRemoveConfirm.bind(this)
    this.handleRemoveSubmit = this.handleRemoveSubmit.bind(this)
    this.handleShowRemoveConfirm = this.handleShowRemoveConfirm.bind(this)
  }

  state = {
    interectedAt: null,
    readAt: null,
    showRemoveConfirm: false
  }

  componentDidMount() {
    const { interectedAt, readAt } = this.props

    return this.setState({
      interectedAt,
      readAt
    })
  }

  handleRemoveConfirm(value) {
    this.setState({ showRemoveConfirm: value })
  }

  handleShowRemoveConfirm() {
    this.handleRemoveConfirm(true)
  }

  async handleRemoveSubmit(event) {
    if (event && event.preventDefault) event.preventDefault()
    if (event && event.stopPropagation) event.stopPropagation()

    const { notificationId, removeNegotiationById } = this.props

    console.log('test', removeNegotiationById)

    if (!removeNegotiationById) return false

    const res = await removeNegotiationById(notificationId)

    return res
  }

  onClickAction(action) {
    const { onClickAction } = this.props

    if (onClickAction) {
      onClickAction(action)
    }

    this.setAsInterected()

    return defaultOnClickAction(action)
  }

  setAsRead() {
    const date = Date.now()

    this.setState({ readAt: date })
  }

  setAsInterected() {
    const date = Date.now()

    this.setState({ interectedAt: date })
  }

  render() {
    const {
      notificationId,
      title,
      image,
      description,
      createdAt,
      productId,
      actions,
      productIcon
    } = this.props

    const { interectedAt, readAt, showRemoveConfirm } = this.state

    const isNotificationRead = isRead(readAt)
    const isNotificationInterected = isInterected(interectedAt)

    const notificationCardClass = classNames(styles.card, {
      [styles.uninteracted]: !isNotificationInterected,
      [styles.unread]: !isNotificationRead
    })

    const createdAtDate = getFormatedCreatedAt(createdAt)

    const actionsComponent = actions.map((action) => (
      <ActionButton
        action={action}
        key={action.id}
        onClick={(event) => {
          if (event) event.preventDefault()

          const newAction = {
            ...action,
            notificationId,
            notificationTitle: title
          }

          return this.onClickAction(newAction)
        }}
      >
        {action.title}
      </ActionButton>
    ))

    const removeConfirmClass = classNames(styles.removeConfirm, {
      [styles.showRemoveConfirm]: showRemoveConfirm
    })

    return (
      <div
        id={`notification-${notificationId}`}
        className={notificationCardClass}
        onMouseLeave={() => this.setAsRead()}
      >
        <div className={styles.container}>
          <NotificationCardHeader
            createdAtDate={createdAtDate}
            productId={productId}
            productIcon={productIcon}
            isRead={isNotificationRead}
            isInterected={isNotificationInterected}
            showRemoveConfirm={this.handleShowRemoveConfirm}
          />

          <div className={styles.content}>
            <div className={styles.image}>
              <Image
                className="notificationImage"
                alt="Notification Image"
                src={image}
                fallback={defaultImage}
              />
            </div>
            <div className={styles.message}>
              <Text
                className={styles.title}
                label={title}
                labelFontSize="16px"
                labelLineHeight="24px"
                color={colors.primaryTextColor}
              />
              <Text
                label={description}
                labelFontSize="12px"
                color={colors.quarternaryTextColor}
              />

              {actions ? (
                <div className={styles.actions}>{actionsComponent}</div>
              ) : null}
            </div>
          </div>
        </div>

        <div className={removeConfirmClass}>
          <Text
            label="Você tem certeza que deseja apagar essa mensagem"
            labelFontSize="16px"
            labelLineHeight="24px"
            margin="24px 0 22px"
            color={colors.primaryTextColor}
          />

          <Text
            label="Sim"
            labelFontSize="12px"
            labelLineHeight="18px"
            color={colors.primaryTextColor}
            width="74px"
            onClick={(event) => this.handleRemoveSubmit(event)}
          />

          <Text
            label="Não"
            labelFontSize="12px"
            labelLineHeight="18px"
            color={colors.redColor}
            width="74px"
            onClick={() => this.handleRemoveConfirm(false)}
          />
        </div>
      </div>
    )
  }
}

NotificationCard.defaultProps = {
  notificationId: null,
  title: null,
  image: null,
  description: null,
  createdAt: null,
  interectedAt: null,
  readAt: null,
  productId: null,
  actions: [],
  productIcon: null,
  onClickAction: null,
  removeNegotiationById: null
}

NotificationCard.propTypes = {
  notificationId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  image: PropTypes.string,
  description: PropTypes.string,
  createdAt: PropTypes.string,
  // Dates can come as string ("2020-01-01") or UNIX date timestamp
  readAt: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  interectedAt: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  productId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      title: PropTypes.string,
      url: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    })
  ),
  productIcon: PropTypes.string,
  onClickAction: PropTypes.func,
  removeNegotiationById: PropTypes.func
}

export default NotificationCard
